module.exports = __webpack_public_path__ + "static/media/entregarinju9.1816f2e4.jpg";